


















import { Vue, Component } from 'vue-property-decorator';
import { LocalRankItem, RankList } from 'src/types/views/home';
import { getRankList } from 'service/api';

@Component
export default class RankListComponent extends Vue {
  rankList: LocalRankItem[] = [];

  async getRankList() {
    const res = await getRankList({
      pageNum: 1,
      pageSize: 10,
    });
    if ((res as RankList).code === 200) {
      this.rankList = (res as RankList).data.rows.map(item => ({
        title: item.title,
        time: item.releaseTim.substr(0, 10),
        id: item.id,
      }));
    }
  }

  mounted() {
    this.getRankList();
  }
}
